import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../utils/media';

export const FeatureFlagContext = createContext({ flags: {}, isEnabled: () => true, refreshFlags: () => {} });

// Flags default to enabled until the fetch resolves, so features aren't
// briefly hidden on every page load while the request is in flight.
export const FeatureFlagProvider = ({ children }) => {
  const [flags, setFlags] = useState({});
  const [loaded, setLoaded] = useState(false);

  const refreshFlags = useCallback(async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/feature-flags`);
      setFlags(response.data);
    } catch (error) {
      console.error('Failed to fetch feature flags', error);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refreshFlags(); }, [refreshFlags]);

  const isEnabled = (key) => {
    if (!loaded || !(key in flags)) return true;
    return Boolean(flags[key]);
  };

  return (
    <FeatureFlagContext.Provider value={{ flags, isEnabled, refreshFlags }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
